import { render, staticRenderFns } from "./upper-brook-street.vue?vue&type=template&id=73b69020&"
import script from "./upper-brook-street.vue?vue&type=script&lang=js&"
export * from "./upper-brook-street.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports